import { input } from '@angular/core';
import * as i0 from "@angular/core";
const _forTrack0 = ($index, $item) => $item[0];
function EditCustomPDFReportConfirmationDetailsComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0);
    i0.ɵɵtext(1, " There was an error. Dismiss this and I will take another look at the request. ");
    i0.ɵɵdomElementEnd();
} }
function EditCustomPDFReportConfirmationDetailsComponent_Conditional_1_Conditional_6_For_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "li")(1, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const attribute_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r1.humanizeAttribute(attribute_r1[0]), ":");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", attribute_r1[1], " ");
} }
function EditCustomPDFReportConfirmationDetailsComponent_Conditional_1_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 1)(1, "span", 2);
    i0.ɵɵtext(2, "Updating:");
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElementStart(3, "ul", 3);
    i0.ɵɵrepeaterCreate(4, EditCustomPDFReportConfirmationDetailsComponent_Conditional_1_Conditional_6_For_5_Template, 4, 2, "li", null, _forTrack0);
    i0.ɵɵdomElementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(ctx_r1.details().edited_attributes);
} }
function EditCustomPDFReportConfirmationDetailsComponent_Conditional_1_Conditional_7_For_5_For_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const moduleLabel_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(moduleLabel_r3);
} }
function EditCustomPDFReportConfirmationDetailsComponent_Conditional_1_Conditional_7_For_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "li")(1, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElementStart(3, "ul", 4);
    i0.ɵɵrepeaterCreate(4, EditCustomPDFReportConfirmationDetailsComponent_Conditional_1_Conditional_7_For_5_For_5_Template, 2, 1, "li", null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵdomElementEnd()();
} if (rf & 2) {
    const page_r4 = ctx.$implicit;
    const ɵ$index_38_r5 = ctx.$index;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Page ", ɵ$index_38_r5 + 1);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(page_r4);
} }
function EditCustomPDFReportConfirmationDetailsComponent_Conditional_1_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 1)(1, "span", 2);
    i0.ɵɵtext(2, "Pages after update:");
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElementStart(3, "ul", 3);
    i0.ɵɵrepeaterCreate(4, EditCustomPDFReportConfirmationDetailsComponent_Conditional_1_Conditional_7_For_5_Template, 6, 1, "li", null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵdomElementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(ctx_r1.details().pages);
} }
function EditCustomPDFReportConfirmationDetailsComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0)(1, "div", 1);
    i0.ɵɵtext(2, "Updates for ");
    i0.ɵɵdomElementStart(3, "span", 2);
    i0.ɵɵtext(4);
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(5, ":");
    i0.ɵɵdomElementEnd();
    i0.ɵɵconditionalCreate(6, EditCustomPDFReportConfirmationDetailsComponent_Conditional_1_Conditional_6_Template, 6, 0, "div", 1);
    i0.ɵɵconditionalCreate(7, EditCustomPDFReportConfirmationDetailsComponent_Conditional_1_Conditional_7_Template, 6, 0, "div", 1);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.details().name);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.details().edited_attributes.length ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.details().pages.length ? 7 : -1);
} }
export class EditCustomPDFReportConfirmationDetailsComponent {
    constructor() {
        this.details = input.required(...(ngDevMode ? [{ debugName: "details" }] : []));
    }
    humanizeAttribute(key) {
        const spaced = key.replace(/_/g, ' ');
        return spaced.charAt(0).toUpperCase() + spaced.slice(1);
    }
}
EditCustomPDFReportConfirmationDetailsComponent.ɵfac = function EditCustomPDFReportConfirmationDetailsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EditCustomPDFReportConfirmationDetailsComponent)(); };
EditCustomPDFReportConfirmationDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EditCustomPDFReportConfirmationDetailsComponent, selectors: [["ycn-edit-custom-pdf-report-confirmation-details"]], inputs: { details: [1, "details"] }, decls: 2, vars: 1, consts: [[1, "text-large", "leading-relaxed", "mb-3"], [1, "mt-2"], [1, "text-bold"], [1, "mt-1", "mb-0"], [1, "mt-0", "mb-0"]], template: function EditCustomPDFReportConfirmationDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, EditCustomPDFReportConfirmationDetailsComponent_Conditional_0_Template, 2, 0, "div", 0)(1, EditCustomPDFReportConfirmationDetailsComponent_Conditional_1_Template, 8, 3, "div", 0);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.details().error ? 0 : 1);
    } }, encapsulation: 2, changeDetection: 0 });
